<template>
  <div>
    <div class="login-container">
      <div class="image-content">
        <img
          class="image-item title"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cc87fb75df39921e1c53f1187b4cb2bf.png"
          alt=""
        />
        <img
          class="image-item cup"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/drink_water_reminder_register_cup"
          alt=""
        />
        <img
          class="image-item text"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/32600444cf89decb60888c5f9ce36e56.png"
          alt=""
        />
        <img
          class="water-droplets-1"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2e378f76d054c4cb4c5a4184a8ef6c07.png"
        />
        <img
          class="water-droplets-2"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2e378f76d054c4cb4c5a4184a8ef6c07.png"
        />
      </div>
      <div class="desc">
        若您尚未注册 betterWE星球
        App，可以先点击下方按钮进行注册，系统会自动为您绑定您的彩虹杯！
      </div>
      <div class="btn" @click="bindRegister">注册绑定</div>
    </div>
    <MyLogin
      title="填写您的信息"
      v-if="showLogin"
      class="login-content"
      @close="bindLoginClose"
      @login="bindLogin"
    ></MyLogin>
  </div>
</template>
<script>
import MyLogin from '@/views/activity/camp-introduce/components/login.vue'
export default {
  components: {
    MyLogin
  },
  data() {
    return {
      showLogin: false
    }
  },
  mounted() {
    /* this.screenHeight = window.innerHeight + 'px';
    window.addEventListener("visibilitychange",()=>{
     if(document.visibilityState === 'visible'){
       window.innerHeight = 900;
     }
    }); */
  },
  methods: {
    bindRegister() {
      this.showLogin = true
    },
    bindLoginClose() {
      this.showLogin = false
    },
    bindLogin(options) {
      let params = {
        phone: options.phone,
        identify_code: options.code,
        areaCode: '86',
        gender: '0',
        r_from: '3'
      }
      this.$http
        .postBaseApp('member/WaterClock/registerWaterUser', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.$toast(res.data.msg || '注册成功')
            setTimeout(() => {
              this.$router.push('/drink-water-reminder/register-success')
            }, 500)
          } else {
            this.$toast(res.msg)
          }
        })
        .catch()
    }
  }
}
</script>
<style lang="scss" scoped>
.login-container {
  width: 100%;
  height: 100vh;
  position: relative;
  background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/110c430ebad17f03af06e7418907c420.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  .image-content {
    width: 100%;
    margin-top: 4.7vh;
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-content: space-between;
    .image-item {
      width: 100%;
      object-fit: contain;
    }
    .title {
      height: 14.6%;
    }
    .cup {
      height: 68.5%;
    }
    .text {
      margin-top: -7.5%;
      height: 24.4%;
    }
    .water-droplets-1 {
      width: 46px;
      height: 46px;
      position: fixed;
      left: 0%;
      transform: translate(-30%, 0%);
      top: 58.4%;
      object-fit: contain;
    }
    .water-droplets-2 {
      width: 54px;
      height: 54px;
      position: fixed;
      right: 0%;
      transform: translate(55%, 0%);
      top: 12%;
      object-fit: contain;
    }
  }
  .desc {
    margin-top: 1.5vh;
    width: 289px;
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 19px;
  }
  .btn {
    text-align: center;
    width: 283px;
    height: 42px;
    line-height: 42px;
    background: #6236ff;
    border-radius: 12px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    margin-top: 5.6vh;
    margin-bottom: 9vh;
  }
}
.login-content {
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0;
}
</style>
